/** True when the Monday status explicitly says the patient has Orthopulse. */
export function hasOrthopulse(orthopulseStatus: string | null | undefined): boolean {
    return (orthopulseStatus ?? '').trim().toLowerCase() === 'yes';
}
